'use strict';

require('./breadcrumbs');
require('./page');
require('./view');

var nav = angular.module('saturn.layout.nav', [
  'saturn.layout.nav.breadcrumbs',
  'saturn.layout.nav.page',
  'saturn.layout.nav.view'
]);

var NavDrawerController = require('./NavDrawerController');
var NavDrawerDirective = require('./NavDrawerDirective');
var NavDrawerService = require('./NavDrawerService');
var NavLeftDirective = require('./NavLeftDirective');
var NavLeftItemDirective = require('./NavLeftItemDirective');

nav.directive('sbNavDrawer', NavDrawerDirective);

nav.controller('sbNavDrawerController', [
  '$scope',
  'sbNavDrawerService',
  NavDrawerController
]);

nav.service('sbNavDrawerService', [
  '$rootScope',
  NavDrawerService
]);

nav.directive('sbNavLeft', [
  NavLeftDirective
]);

nav.directive('sbNavLeftItem', [
  NavLeftItemDirective
]);


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/layout/src/nav/index.js